import React, { useEffect } from 'react';

export default function DocumentTitle({ title = '' }) {
  useEffect(() => {
    document.title = `DTL | ${title}`;
  }, [title]);
  return (
    <div className="sr-only invisible" role="alert" aria-live="assertive" aria-relevant="additions" aria-atomic="true">
      {`DTL | ${title} page`}
    </div>
  );
}
